/**
 * Utility function to share content using Web Share API or fallback to clipboard
 * @param {Object} options - Share options
 * @param {string} options.url - The URL to share
 * @param {string} options.title - The title of the content
 * @param {string} [options.text] - Optional description text
 * @param {string} [options.successMessage] - Optional custom success message for clipboard copy
 * @returns {Promise<boolean>} - Returns true if sharing was successful
 */
export const shareContent = async ({
  url,
  title,
  text = null,
  successMessage = "¡Link copiado al portapapeles!",
}) => {
  try {
    // Validate required parameters
    if (!url || !title) {
      console.error("shareContent: url and title are required parameters");
      return false;
    }

    // Check if Web Share API is available (mobile devices)
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: text || `¡Mira esto! ${title}`,
          url,
        });
        return true;
      } catch (error) {
        // User cancelled the share dialog (AbortError) - not a real error
        if (error.name !== "AbortError") {
          console.error("Error sharing:", error);
          // Fall through to clipboard fallback
        } else {
          // User cancelled, still return false but no error logged
          return false;
        }
      }
    }

    // Fallback for desktop: copy to clipboard
    try {
      await navigator.clipboard.writeText(url);
      alert(successMessage);
      return true;
    } catch (error) {
      console.error("Error copying to clipboard:", error);
      return false;
    }
  } catch (error) {
    console.error("Unexpected error in shareContent:", error);
    return false;
  }
};
